import { AnyObj } from '../../../types/common';


/** 但文件大小限制 */
let sysMaxSingleUploadSize: number | null = null;
/** 文件类型黑名单 */
let sysFormatBlacks: string | null = null;
/** 文件上传白名单 */
let sysFormatWhites: string | null = null;
/** 判断当前需要校验系统白名单还是系统黑名单 */
let sysFormatWhitesEnable: boolean | null = null;
/** 接口是否加载完成 */
let isLoadSetting: boolean | 'loading' = false;

/** 请求接口获取系统文件上传校验规则 */
export const reqSystemUploadCheckConfig = (loginFree?: boolean) => {
  return import(
    /* webpackChunkName: "upload" */
    './systemUploadCheckAsync').then((defaultModule) => defaultModule?.reqSystemUploadCheckConfig(
      loginFree,
      isLoadSetting
    ));
}

export const setLoadingSetting = (loaded: boolean | 'loading') => {
  isLoadSetting = loaded;
}

export const setSystemUploadCheckConfig = (params: AnyObj) => {
  sysMaxSingleUploadSize = params?.sysMaxSingleUploadSize;
  sysFormatBlacks = params?.sysFormatBlacks;
  sysFormatWhites = params?.sysFormatWhites;
  sysFormatWhitesEnable = params?.sysFormatWhitesEnable;
}
/** 获取系统附件大小限制、附件类型白名单/黑名单配置 */
export const getSystemUploadCheckConfig = () => {
  return { sysMaxSingleUploadSize, sysFormatBlacks, sysFormatWhites, sysFormatWhitesEnable };
}
